import { TypedStartListening } from "@reduxjs/toolkit";
import type { IAppState } from ".";
import { apiSlice } from "../api/apiSlice";

// RTK Query caches `me` resources under one key whoever is signed in, so drop
// every entry when the user leaves, before the next user can be served it.
export const addResetApiStateListener = (
    startListening: TypedStartListening<IAppState>
) =>
    startListening({
        type: "LOGOUT_USER",
        effect: (_action, api) => {
            api.dispatch(apiSlice.util.resetApiState());
        }
    });
